var _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFileInput(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_108_1",
    "data-name": "Component 108 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_2147",
    "data-name": "Ellipse 2147",
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#059ac1"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "document",
    transform: "translate(-43.664 14)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_79226",
    "data-name": "Path 79226",
    d: "M75.711,8.2A1.916,1.916,0,0,1,73.8,6.289V0H64.008A3.011,3.011,0,0,0,61,3.008V24.992A3.011,3.011,0,0,0,64.008,28H79.32a3.011,3.011,0,0,0,3.008-3.008V8.2ZM65.484,19.688h3.977a.82.82,0,0,1,0,1.641H65.484a.82.82,0,0,1,0-1.641Zm-.82-3.555a.82.82,0,0,1,.82-.82H77.516a.82.82,0,0,1,0,1.641H65.484A.82.82,0,0,1,64.664,16.133Zm12.852-5.2a.82.82,0,0,1,0,1.641H65.484a.82.82,0,0,1,0-1.641Z",
    transform: "translate(0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_79227",
    "data-name": "Path 79227",
    d: "M325,12.17a.274.274,0,0,0,.273.273h6.252a3,3,0,0,0-.575-.751L325.677,6.7A3.016,3.016,0,0,0,325,6.221V12.17Z",
    transform: "translate(-249.563 -5.881)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileInput);
export default __webpack_public_path__ + "static/media/file_input.24dfe02fa2a4201e8116dd561e3de39d.svg";
export { ForwardRef as ReactComponent };